import { MatsForAccount } from "@mezo/api"
import { createSlice } from "@reduxjs/toolkit"

export type MatsRewards = MatsForAccount & {
  isLoading: boolean
}

export type RewardsState = {
  mats: MatsRewards
}

export const initialMats: MatsRewards = {
  totalMats: 0,
  inactiveMats: 0,
  matsActivated: false,
  isLoading: false,
}

const initialState: RewardsState = {
  mats: initialMats,
}

const rewardsSlice = createSlice({
  name: "rewards",
  initialState,
  reducers: {
    setMats: (immerState, { payload }: { payload: MatsForAccount }) => {
      immerState.mats = { ...payload, isLoading: false }
    },
    setMatsLoading: (immerState, { payload }: { payload: boolean }) => {
      immerState.mats.isLoading = payload
    },
    resetMats: (immerState) => {
      immerState.mats = initialMats
    },
  },
})

export const { setMats, setMatsLoading, resetMats } = rewardsSlice.actions

export default rewardsSlice.reducer
